import React, {useContext, useEffect, useRef, useState} from "react";

import {ConfirmDialog} from "./Dialog";

const DialogContext = React.createContext();
export const DialogPortal = ({children}) => {
  const [controller, setController] = useState(null);
  const dialogRef = useRef(null);

  useEffect(() => {
    setController(dialogRef.current);
  }, []);

  return (
    <DialogContext.Provider value={controller}>
      {children}
      <ConfirmDialog ref={dialogRef} />
    </DialogContext.Provider>
  );
};

/**
 * params: {title, message, cancelText, okText}
 * @returns {openDialogAsync}
 */
export const useAsyncDialog = () => {
  return [
    useContext(DialogContext),
    {
      CANCEL: "CANCEL",
      OK: "OK"
    }
  ];
};
